import { Box, Tooltip } from '@mui/material';
import React, { useEffect } from 'react';

import { useSxStyles } from './useStyles';

export interface Props {
  title?: React.ReactNode;
  children: NonNullable<React.ReactNode>;
  dataCy?: string;
}

export const TooltippedTruncatedText: React.FC<Props> = ({
  title,
  children,
  dataCy,
}) => {
  const sxStyles = useSxStyles();
  const ref = React.useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = React.useState(false);
  const scrollWidth = ref.current?.scrollWidth;
  const offsetWidth = ref.current?.offsetWidth;

  useEffect(() => {
    if (ref.current) {
      setIsTruncated(ref.current.scrollWidth > ref.current.offsetWidth);
    }
  }, [scrollWidth, offsetWidth]);

  useEffect(() => {
    if (ref.current) {
      setIsTruncated(ref.current.scrollWidth > ref.current.offsetWidth);
    }
  }, []);

  if (isTruncated) {
    return (
      <Tooltip ref={ref} title={title || children}>
        <Box component="span" sx={sxStyles.text} data-cy={dataCy}>
          {children}
        </Box>
      </Tooltip>
    );
  }

  return (
    <Box component="span" ref={ref} sx={sxStyles.text} data-cy={dataCy}>
      {children}
    </Box>
  );
};
